module.exports = __webpack_public_path__ + "img/noon.7912d2ce.svg";